import { type AnalyticsAttributes } from '@atlassian/analytics-bridge';
import {
	getChildren,
	getChildrenWithNextUrl,
	getDrafts,
	PAGE_SIZE_LIMIT,
} from '../../services/confluence';
import { type ConfluenceTableTreeData } from './confluence-table-tree-data';
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { type EventName } from './types';

export const firePageTreeOperationalEvents = ({
	eventName,
	analyticsAttributes,
	createAnalyticsEvent,
}: {
	eventName: EventName;
	analyticsAttributes: AnalyticsAttributes;
	createAnalyticsEvent: Function;
}) => {
	if (createAnalyticsEvent) {
		fireOperationalAnalytics(
			createAnalyticsEvent({}),
			`confluencePageTree ${eventName}`,
			analyticsAttributes,
		);
	}
};

export const updatePublishedPageTreeItems = async (
	spaceKey: string | null,
	parentContentId: string | null,
	isRoot: boolean,
	start: number,
	tableTreeData: ConfluenceTableTreeData,
	maxPages?: number,
	projectId?: number,
	projectType?: string,
) => {
	const publishedPages = await getChildren(
		spaceKey,
		parentContentId,
		PAGE_SIZE_LIMIT,
		start,
		maxPages,
		projectId,
		projectType,
	);
	const pageTreeItems = tableTreeData.updateChildPages(
		publishedPages,
		isRoot ? undefined : parentContentId || undefined,
	);

	return pageTreeItems;
};

export const fetchPublishedPageTreeItems = async (
	spaceKey: string | null,
	parentContentId: string | null,
	isRoot: boolean,
	start: number,
	tableTreeData: ConfluenceTableTreeData,
	projectId?: number,
	projectType?: string,
) => {
	const { pages: publishedPages, next } = await getChildrenWithNextUrl(
		spaceKey,
		parentContentId,
		start,
		projectId,
		projectType,
	);

	const pageTreeItems = tableTreeData.apppendChildPages(
		publishedPages ?? [],
		isRoot ? undefined : parentContentId || undefined,
	);

	return {
		pageTreeItems,
		next,
	};
};

export const fetchDraftsPageTreeItems = async (
	spaceKey: string | null,
	parentContentId: string | null,
	tableTreeData: ConfluenceTableTreeData,
	projectId?: number,
	projectType?: string,
) => {
	const drafts = await getDrafts(spaceKey, parentContentId, projectId, projectType);
	return tableTreeData.injectPages(drafts);
};
